import { atom } from "recoil";

export const prodAddState = atom({
  key: "prodAddState",
  default: false,
});
export const prodEditState = atom({
  key: "prodEditState",
  default: false,
});
export const selectedRowsProdCode = atom({
  key: "selectedRowsProdCode",
  default: [],
});
export const setRowForEditProdCode = atom({
  key: "setRowForEditProdCode",
  default: {},
});

export const carrierProgramOptions = atom({
  key: "carrierProgramOptions",
  default: [],
});

export const mgaOptions = atom({
  key: "mgaOptions",
  default: [],
});

export const carrierId = atom({
  key: "carrierId",
  default: [],
});

export const initialProdData = atom({
  key: "initialProdData",
  default: [
    {
      producerCodeRowId: 0,
      producerCode: "",
      producerSubCode: "",
      lineOfBusiness: [],
      isMA: false,
      maProducerCode: "",
      program: "",
      mga: "",
    },
  ],
});

export const isEditStateProducer = atom({
  key: "isEditStateProducer",
  default: false,
});

export const rowForEditProducer = atom({
  key: "rowForEditProducer",
  default: [],
});

export const prodCodeList = atom({
  key: "prodCodeList",
  default: [],
});

export const defaultOfficeValueForEdit = atom({
  key: "defaultOfficeValueForEdit",
  default: [],
});

export const saveButtonTextProducerCode = atom({
  key: "saveButtonTextProducerCode",
  default: "Save",
});

export const defaultProdSearchParams = {
  CarrierName: [],
  OfficeName: [],
  OfficeCode: [],
  State: [],
  ProducerCode: "",
  MAProducerCode: "",
  IsFranchise: false,
  IsConfie: false,
  AcquisitionName: "",
  carrierProducerCodes: null,

  //for filters fields
  selectedFranchiseConfie: [],
  selectedState: [],
  selectedCarrier: [],
  selectedOffice: [],
  selectedProducerCode: "",
  selectedMaProducerCode: "",
  selectedAcquisitionName: "",
};
export const searchDataProdCode = atom({
  key: "searchDataProdCode",
  default: defaultProdSearchParams,
});

export const isProdCodeFilterOpen = atom({
  key: "isProdCodeFilterOpen",
  default: false,
});

export const isFranchiseFilterState = atom({
  key: "isFranchiseFilterState",
  default: false,
});

export const isForFranchiseDataState = atom({
  key: "isFranchiseDataState",
  default: false,
});

export const selectedEmployeeState = atom({
  key: "selectedEmployeeState",
  default: [],
});

export const fromRecentActivity = atom({
  key: "fromRecentActivity",
  default: false,
});
export const fromRecentActivityId = atom({
  key: "fromRecentActivityId",
  default: null,
});

export const prodcodeFilterParams = atom({
  key: "prodCodeFilterParams",
  default: undefined,
});

export const searchedProdCodeTableData = atom({
  key: "searchedProdCodeTableData",
  default: [],
});

export const prodCodeMastercarrierId = atom({
  key: "prodCodeMastercarrierId",
  default: undefined,
});

export const prodCodeIsFranchise = atom({
  key: "prodCodeIsFranchise",
  default: false,
});

export const carrierNameValue = atom({
  key: "carrierNameValue",
  default: "",
});

export const prodCodeShowState = atom({
  key: "prodCodeShowState",
  default: false,
});

export const prodCodeViewData = atom({
  key: "prodCodeViewData",
  default: [],
});

export const prodCodeExandedRow = atom({
  key: "prodCodeExandedRow",
  default: [],
});